export default function getAIDraftFeedbackMetadata(usePeriwinkle: boolean) {
  return {
    schema: {
      type: 'object',
      properties: {
        FeedbackStars: {
          title: 'How would you rate the quality of this draft?',
          name: 'FeedbackStars',
          type: 'number',
          starLabels: ['Terrible', 'Bad', 'Okay', 'Good', 'Great'],
          backgroundColor: usePeriwinkle ? 'periwinkle' : undefined,
          testID: 'SatisfactionSurvey',
          validation: {
            isRequired: true,
          },
        },
        wordCloudSelection1to3stars: {
          title: 'Anything specific?',
          name: 'wordCloudSelection1to3stars',
          type: 'string',
          enum: ['Inaccurate', 'Not specific', 'Strange tone'],
          condition: {
            parentField: 'FeedbackStars',
            parentValue: [1, 2],
          },
          modifier: usePeriwinkle ? 'periwinkle' : undefined,
        },
        wordCloudSelection4to5stars: {
          title: 'Anything specific?',
          name: 'wordCloudSelection4to5stars',
          type: 'string',
          enum: ['Accurate', 'Comprehensive', 'Appropriate tone'],
          condition: {
            parentField: 'FeedbackStars',
            parentValue: [3, 4, 5],
          },
          modifier: usePeriwinkle ? 'periwinkle' : undefined,
        },
        tellUsMore: {
          name: 'tellUsMore',
          type: 'string',
          title: 'Tell us more',
          placeholder: 'Your feedback',
          numberOfLines: 1,
          condition: {
            parentField: 'FeedbackStars',
            parentValue: [1, 2, 3, 4, 5],
          },
        },
      },
    },
    uiSchema: {
      'ui:order': ['FeedbackStars', 'wordCloudSelection1to3stars', 'wordCloudSelection4to5stars', 'tellUsMore'],
      FeedbackStars: {
        'ui:widget': 'feedbackStars',
      },
      wordCloudSelection1to3stars: {
        'ui:widget': 'wordCloud',
      },
      wordCloudSelection4to5stars: {
        'ui:widget': 'wordCloud',
      },
      tellUsMore: {
        'ui:widget': 'textarea',
      },
    },
  }
}
